var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-date-filter"},[_c('RInputWithSigns',{ref:"input",attrs:{"value":_vm.formattedValue,"sign":_vm.sign},on:{"sign-changed":_vm.signChanged,"clear-filter":_vm.clearFilter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }